/* eslint-disable no-param-reassign */
import Vue from 'vue';

export default {
  state: {
    contactStatuses: [],
    customerStatuses: [],
  },
  getters: {
    customerStatuses(state) {
      return state.customerStatuses;
    },
    customerStatus: state => id => state.customerStatuses.find(status => status.id === id) || {},
    contactStatuses(state) {
      return state.contactStatuses;
    },
    contactStatus: state => id => state.contactStatuses.find(status => status.id === id) || {},
  },
  mutations: {
    SET_CUSTOMER_STATUSES(state, payload) {
      state.customerStatuses = payload;
    },
    SET_CONTACT_STATUSES(state, payload) {
      state.contactStatuses = payload;
    },
  },
  actions: {
    GET_CUSTOMER_STATUSES({ state, commit }) {
      if (state.contactStatuses.length < 1 && state.customerStatuses.length < 1) {
        return Vue.axios.get('customers/status').then((response) => {
          const customer = response.data.customer.map((item) => {
            item.name = item.status;
            return item;
          });
          commit('SET_CUSTOMER_STATUSES', customer);
          const contact = response.data.contact.map((item) => {
            item.name = item.status;
            return item;
          });
          commit('SET_CONTACT_STATUSES', contact);
        });
      }
      return new Promise((resolve) => {
        resolve('ready');
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/customer_status.js